import type { FC } from 'react'
import React from 'react'

import NumberBadge from '@vfuk/core-number-badge'

import type { IconSocialPaypalProps } from './IconSocialPaypal.types'
import * as Styled from './styles/IconSocialPaypal.style'

import { nonThemeableRules } from '../../ruleSet'

const IconSocialPaypal: FC<IconSocialPaypalProps> = ({
  size = nonThemeableRules.defaultSize as number as IconSocialPaypalProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
  numberBadge,
}: IconSocialPaypalProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M19.695 11.086v-.024a2.837 2.837 0 0 0-1.05-2.187l.046-.21a6.43 6.43 0 0 0 .125-1.25V6.93a3.922 3.922 0 0 0-3.648-3.914.457.457 0 0 0-.125-.016H7.832a1.198 1.198 0 0 0-1.191 1.012L4.312 18.238a.876.876 0 0 0 .875 1.012h3.395l-.207 1.25a.441.441 0 0 0 .375.5h2.781a.701.701 0 0 0 .7-.582l.582-3.57a.765.765 0 0 1 .25-.383.714.714 0 0 1 .374-.133c.723.012.626-.012 1.344 0h.14c.044 0 .067.012.102.012h.04v-.012c2.226-.082 4.636-2.23 4.636-5.145 0-.035-.004-.062-.004-.101Zm-9.363 1.539a.237.237 0 0 0-.074 0h-.02a1.21 1.21 0 0 0-.675.27 1.43 1.43 0 0 0-.465.73l-.012.047-.293 1.75-.5 2.84H5.32l2.305-14.09A.203.203 0 0 1 7.832 4h7.125l.066.008a2.919 2.919 0 0 1 2.79 2.918v.136a7.39 7.39 0 0 1-.051 1.094c-.524 2.73-2.82 4.442-4.75 4.469Zm0 0'
          fill='none'
          vectorEffect='non-scaling-stroke'
        />
      </svg>
      <If condition={numberBadge}>
        <Styled.NumberBadgeContainer>
          <NumberBadge number={numberBadge!} appearance={inverse ? appearance : 'primary'} />
        </Styled.NumberBadgeContainer>
      </If>
    </Styled.IconWrapper>
  )
}

export default IconSocialPaypal
